module.exports = __webpack_public_path__ + "media/images/logo/Logo_g-cf030c7a9409e119c0da48ee0c681b54.jpg";